import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { CartProvider } from "@/contexts/CartContext";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Order from "@/pages/Order";
import Checkout from "@/pages/Checkout";
import Confirmation from "@/pages/Confirmation";
import Tracking from "@/pages/Tracking";
import Reservation from "@/pages/Reservation";
import MenuRedirect from "@/pages/MenuRedirect";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import { Navigate } from "react-router-dom";

export default function App() {
  return (
    <div className="App">
      <CartProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/commander" element={<Order />} />
              <Route path="/order-online" element={<Navigate to="/commander" replace />} />
              <Route path="/order" element={<Navigate to="/commander" replace />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/confirmation/:id" element={<Confirmation />} />
              <Route path="/suivi/:id" element={<Tracking />} />
              <Route path="/reserver" element={<Reservation />} />
              <Route path="/menu" element={<MenuRedirect />} />
            </Route>
            <Route path="/hana/dashboard" element={<AdminLogin />} />
            <Route path="/hana/dashboard/panel" element={<AdminDashboard />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </CartProvider>
    </div>
  );
}
